import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
// import { ReactComponent as Info } from "../../assets/images/Info.svg";
import {
  attorney_LandingPage,
  client_add_bank_details,
  client_LandingPage,
  client_personal_bank_details,
  client_request_bankList_details,
  famVault_wesbite,
} from "../../constants/routes";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  accountNumberRules,
  bankNameRules,
  firstNameRules,
  routingNumberRules,
  subsidiaryName,
  zipRules,
} from "../../constants/regExp";
import * as yup from "yup";
import { validation } from "../../constants/client/validationMessages";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { bankDetailsLabel, clientTitle } from "../../constants/client/labels";
import AttorneyTitleBar from "../attorney/AttorneyTitleBar";
import {
  useAddBankDetailsMutation,
  useRequestAddBankDetailsMutation,
} from "../../slices/wireTransferApiManagementSlice";
import Loader from "../Loader/Loader";
import { accountType } from "../../constants/client/mockData";
import {
  clientPlaceholder,
  cliManagement,
} from "../../constants/attorney/lables";
import { useShareBankDetailsEmailMutation } from "../../slices/wireTransferAuthManagemementSlice";
import BankShareConfirmationPopup from "../modal/BankShareConfirmationPopup";
import { setEmptyDetails } from "../../slices/shareReceiveBankDetailsSlice";
import { FIVE_MINUTES } from "../../constants/idleTimer";
import axios from "axios";
import HeaderProfileWireTransfer from "../headers/HeaderProfileWireTransfer";
import { useGetGeoCodesZipCodeQuery } from "../../slices/userRegistrationApiManagemnetSlice";

export default function AddBankDetails({ refetchData }) {
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const [buttonName, setButtonName] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [bankData, setBankData] = useState({});
  const dispatch = useDispatch();
  const [zipCode, setZipCode] = useState("");
  const [bankzip, setBankZip] = useState("");
  const [cities, setCities] = useState([]);
  const [bankcities, setBankCities] = useState([]);
  // const [showRipon, setShowRipon] = useState(true);

  const [items, setItems] = useState([
    {
      id: "item-1",
      link: client_LandingPage,
      content: clientTitle,
      active: false,
      state: { id: userInfo?.firmTypeId },
    },
  ]);
  const isNotificationPage = location?.state?.page === "requestBankDetails";
  const isEmailPage = location?.state?.page === "requestBankDetailsEmail";
  const isAlreadyShared =
    location?.state?.page === "viewBankDetailEmail" ||
    location?.state?.page === "requestBankDetailsAdd";
  const isAlreadySharedNoti =
    location?.state?.page === "requestBankDetailsAddNoti";
  let transactionId = isEmailPage && location?.state?.transactionId;
  let identifierID = isEmailPage && location?.state?.identifierID;
  if (location?.state?.page === "requestBankDetails") {
    const apiUrl = location?.state?.id[0]?.apiUrl;
    const urlObj = new URL(apiUrl);
    const queryParameters = new URLSearchParams(urlObj.search);
    transactionId = queryParameters.get("transactionId");
  }
  const fromOtpPage = sessionStorage.getItem("fromOtpPage");
  const isRightPath =
    location?.state?.page === "requestBankDetailsEmail" ||
    location?.state?.page === "viewBankDetailEmail"
      ? fromOtpPage === "Yes"
      : true;

  useEffect(() => {
    if (
      location?.state?.page === "requestBankDetails" ||
      location?.state?.page === "requestBankDetailsAddNoti"
    ) {
      if (userInfo?.role === "ATT") {
        setItems([
          {
            id: "item-1",
            link: attorney_LandingPage,
            content: cliManagement,
            active: false,
          },
        ]);
      }
      setButtonName(bankDetailsLabel?.share);
    } else if (
      location?.state?.page === "viewBankDetailEmail" ||
      location?.state?.page === "requestBankDetailsEmail"
    ) {
      setItems([]);
      setButtonName(bankDetailsLabel?.share);
    } else if (
      location?.state?.page === "bankDetails" ||
      location?.state?.page === "bankDetailsList"
    ) {
      setItems([
        {
          id: "item-1",
          link: client_LandingPage,
          content: clientTitle,
          active: false,
          state: { id: userInfo?.firmTypeId },
        },
        {
          id: "item-2",
          link: client_add_bank_details,
          content: bankDetailsLabel?.bankDetails,
          active: false,
        },
      ]);
      setButtonName(bankDetailsLabel?.save);
    } else {
      setButtonName(bankDetailsLabel?.save);
    }
  }, [location, userInfo]);

  const handleLogout = useCallback(async () => {
    try {
      const url = `${process.env.REACT_APP_BASE_URL_BANKINGSERVICE}/api/v1/transactions/logout?identifier=${location?.state?.identifier}`;
      await axios({
        url: url,
        method: "GET",
      });
      toast.success("Signed out successfully...");
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
    dispatch(setEmptyDetails());
    sessionStorage.clear();
    window.location.replace(famVault_wesbite);
  }, [dispatch, location?.state?.identifier]);

  useEffect(() => {
    if (userInfo === null && !location?.state) {
      window.location.href = famVault_wesbite;
    }
    if (!isRightPath) {
      handleLogout();
    }
  }, [location, navigate, userInfo, isRightPath, handleLogout]);

  useEffect(() => {
    let logoutInterval;
    const LOGOUT_INTERVAL = FIVE_MINUTES;
    const handleAutoLogout = () => {
      handleLogout();
    };

    const initializeLogoutTimer = () => {
      const storedTime = sessionStorage.getItem("logoutTime");
      const currentTime = Date.now();

      if (storedTime) {
        const remainingTime = Number(storedTime) - currentTime;

        if (remainingTime > 0) {
          logoutInterval = setInterval(() => {
            const timeLeft = Number(storedTime) - Date.now();

            if (timeLeft <= 0) {
              clearInterval(logoutInterval);
              handleAutoLogout();
            }
          }, 1000);
        } else {
          handleAutoLogout();
        }
      } else {
        const logoutTime = currentTime + LOGOUT_INTERVAL;
        sessionStorage.setItem("logoutTime", logoutTime);
        logoutInterval = setInterval(() => {
          const timeLeft = logoutTime - Date.now();

          if (timeLeft <= 0) {
            clearInterval(logoutInterval);
            handleAutoLogout();
          }
        }, 1000);
      }
    };
    if (
      location?.state?.page === "requestBankDetailsEmail" ||
      location?.state?.page === "viewBankDetailEmail"
    ) {
      initializeLogoutTimer();
    }
  }, [handleLogout, location?.state?.page]);

  const schema = yup.object().shape({
    firstName: yup
      .string()
      .trim()
      .required(`${validation.firstName.required}`)
      .matches(firstNameRules, `${validation.firstName.rule}`),
    lastName: yup
      .string()
      .trim()
      .matches(firstNameRules, `${validation.lastName.rule}`),
    routingNumber: yup
      .string()
      .required(`${validation.routingNumber.required}`)
      .matches(routingNumberRules, {
        message: `${validation.routingNumber.routingNumberRules}`,
      }),
    reRoutingNumber: yup
      .string()
      .required(`${validation.routingNumber.required}`)
      .oneOf([yup.ref("routingNumber"), null], "Routing Number Mismatch"),
    bankName: yup
      .string()
      .trim()
      .required(`${validation.bankName.required}`)
      .matches(bankNameRules, `${validation.bankName.required}`),
    branchName: yup
      .string()
      .trim()
      .required(`${validation.branchName.required}`)
      .matches(bankNameRules, `${validation.bankName.required}`),
    accountType: yup
      .string()
      .notOneOf([""], `${validation.accountType.required}`)
      .required(),
    accountNumber: yup
      .string()
      .required(`${validation.accountNumber.required}`)
      .matches(accountNumberRules, {
        message: `${validation.accountNumber.accountNumberRules}`,
      }),
    reAccNumber: yup
      .string()
      .required(`${validation.accountNumber.required}`)
      .oneOf([yup.ref("accountNumber"), null], "Account Number Mismatch"),
    subsidiaryName: yup
      .string()
      .trim()
      .required(`${validation.subsidiaryName.required}`)
      .matches(subsidiaryName, `${validation.subsidiaryName.rule}`),
    beneficiary_addressLine1: yup
      .string()
      .trim()
      .required(`${validation.addressLine1.required}`),
    beneficiary_addressLine2: yup.string().trim(),
    beneficiary_zip: yup
      .string()
      .trim()
      .matches(zipRules, { message: `${validation.zip.zipRules}` }),
    beneficiary_state: yup.string().required(`${validation.state.required}`),
    beneficiary_country: yup
      .string()
      .required(`${validation.country.required}`),
    beneficiary_cityList: yup.mixed().when("beneficiary_city", {
      is: null,
      then: () =>
        yup
          .string()
          .notOneOf([""], `${validation.cityList.required}`)
          .required(),
      otherwise: (schema) => schema.notRequired(),
    }),
    beneficiary_city: yup
      .string()
      .required(`${validation.city.required}`)
      .nullable(),
    recipient_addressLine1: yup
      .string()
      .trim()
      .required(`${validation.addressLine1.required}`),
    recipient_addressLine2: yup.string().trim(),
    recipient_zip: yup
      .string()
      .trim()
      .matches(zipRules, { message: `${validation.zip.zipRules}` }),
    recipient_state: yup.string().required(`${validation.state.required}`),
    recipient_country: yup.string().required(`${validation.country.required}`),
    recipient_cityList: yup.mixed().when("recipient_city", {
      is: null,
      then: () =>
        yup
          .string()
          .notOneOf([""], `${validation.cityList.required}`)
          .required(),
      otherwise: (schema) => schema.notRequired(),
    }),
    recipient_city: yup
      .string()
      .required(`${validation.city.required}`)
      .nullable(),
  });

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema), mode: "all" });

  useEffect(() => {
    if (isAlreadyShared || isAlreadySharedNoti) {
      const {
        firstName,
        lastName,
        routingNumber,
        bankName,
        branchName,
        accountType,
        accountNumber,
        subsidiaryName,
        userAddress,
        bankAddress,
      } = location?.state?.data?.data[0];
      setValue("firstName", firstName || "");
      setValue("lastName", lastName || "");
      setValue("routingNumber", routingNumber || "");
      setValue("reRoutingNumber", routingNumber || "");
      setValue("bankName", bankName || "");
      setValue("branchName", branchName || "");
      setValue("accountType", accountType || "");
      setValue("accountNumber", accountNumber || "");
      setValue("reAccNumber", accountNumber || "");
      setValue("subsidiaryName", subsidiaryName || "");
      setValue("recipient_addressLine1", userAddress?.addressLine1 || "");
      setValue("recipient_addressLine2", userAddress?.addressLine2 || "");
      setValue("recipient_city", userAddress?.city || "");
      setValue("recipient_state", userAddress?.state || "");
      setValue("recipient_country", userAddress?.country || "");
      setValue("recipient_zip", userAddress?.zip || "");
      setValue("beneficiary_addressLine1", bankAddress?.addressLine1 || "");
      setValue("beneficiary_addressLine2", bankAddress?.addressLine2 || "");
      setValue("beneficiary_city", bankAddress?.city || "");
      setValue("beneficiary_state", bankAddress?.state || "");
      setValue("beneficiary_country", bankAddress?.country || "");
      setValue("beneficiary_zip", bankAddress?.zip || "");
    } else {
      reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.state?.page]);

  const [addBankDetail, { isLoading: addBankDetailLoading }] =
    useAddBankDetailsMutation({
      skip: isNotificationPage,
    });

  const [requestShareBankDetail, { isLoading: requestShareBankDetailLoading }] =
    useRequestAddBankDetailsMutation({
      skip: !isNotificationPage,
    });
  const [shareBankDetails, { isLoading: shareBankDetailsLoading }] =
    useShareBankDetailsEmailMutation({
      skip: !isEmailPage,
    });
  const { data: geoCodeData, isLoading: geoCodeLoading } =
    useGetGeoCodesZipCodeQuery(zipCode, {
      skip: zipCode?.length !== 5,
    });
  const { data: bankGeoCodeData, isLoading: bankGeoCodeLoading } =
    useGetGeoCodesZipCodeQuery(bankzip, {
      skip: bankzip?.length !== 5,
    });

  useEffect(() => {
    const data = geoCodeData;
    if (data && data?.status === "OK") {
      let usResult = data?.results.find((result) => {
        let country = result.address_components.find((ac) =>
          ac.types.includes("country")
        )?.long_name;
        return (
          country === "United States" ||
          country === "Puerto Rico" ||
          country === "U.S. Virgin Islands" ||
          country === "American Samoa" ||
          country === "Northern Mariana Islands" ||
          country === "Guam"
        );
      });

      let multipleCities = usResult?.postcode_localities;

      let city = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("locality")
      )[0]?.long_name;

      let city1 = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("sublocality")
      )[0]?.long_name;

      let city2 = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("neighborhood")
      )[0]?.long_name;

      let city3 = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("administrative_area_level_3")
      )[0]?.long_name;

      let city4 = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("administrative_area_level_2")
      )[0]?.long_name;

      let state = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("administrative_area_level_1")
      )[0]?.long_name;

      let country = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("country")
      )[0]?.long_name;

      if (country === "United States") {
        let allCities = [
          city,
          city1,
          city2,
          city3,
          city4,
          ...(multipleCities || []).flatMap((city) =>
            city.split(",").map((c) => c.trim())
          ),
        ];

        allCities = allCities.filter(Boolean);

        allCities = [...new Set(allCities)];

        allCities.sort((a, b) => a.localeCompare(b));

        if (allCities && allCities?.length === 1) {
          setCities([]);
          const filteredCity = allCities[0];
          setValueZip(filteredCity, state, country);
        } else if (allCities && allCities?.length > 0) {
          setCities(allCities);
          setValueZip(null, state, country);
        } else {
          setCities([]);
          setValueZip("", "", "");
          toast("Please provide the valid zip code");
        }
      }

      if (
        country === "Puerto Rico" ||
        country === "U.S. Virgin Islands" ||
        country === "American Samoa" ||
        country === "Northern Mariana Islands" ||
        country === "Guam"
      ) {
        let allCities = [
          city,
          city1,
          city2,
          city3,
          city4,
          state,
          ...(multipleCities || []).flatMap((city) =>
            city.split(",").map((c) => c.trim())
          ),
        ];

        allCities = allCities.filter(Boolean);

        allCities = [...new Set(allCities)];

        allCities.sort((a, b) => a.localeCompare(b));

        if (allCities && allCities?.length === 1) {
          setCities([]);
          const filteredCity = allCities[0];
          setValueZip(filteredCity, country, "United States");
        } else if (allCities && allCities?.length > 0) {
          setCities(allCities);
          setValueZip(null, country, "United States");
        } else {
          setCities([]);
          setValueZip("", "", "");
          toast("Please provide the valid zip code");
        }
      }

      if (
        country !== "United States" &&
        country !== "Puerto Rico" &&
        country !== "U.S. Virgin Islands" &&
        country !== "Northern Mariana Islands" &&
        country !== "Guam" &&
        country !== "American Samoa"
      ) {
        toast("Please provide the US zip code");
        setCities([]);
        setValueZip("", "", "");
      }
    } else {
      if (data !== undefined) {
        if (data && data?.status === "ZERO_RESULTS") {
          toast("Please provide the valid zip code");
          setCities([]);
          setValueZip("", "", "");
        } else {
          data?.error_message
            ? toast(`${data?.error_message}`)
            : toast("somthing went wrong");
          setCities([]);
          setValueZip("", "", "");
        }
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [geoCodeData]);

  const setValueZip = (city, state, country) => {
    setValue("recipient_city", city, {
      shouldValidate: true,
      shouldTouch: true,
      shouldDirty: true,
    });
    setValue("recipient_state", state, {
      shouldValidate: true,
      shouldTouch: true,
      shouldDirty: true,
    });

    setValue("recipient_country", country, {
      shouldValidate: true,
      shouldTouch: true,
      shouldDirty: true,
    });
  };
  useEffect(() => {
    const data = bankGeoCodeData;
    if (data && data?.status === "OK") {
      let usResult = data?.results.find((result) => {
        let country = result.address_components.find((ac) =>
          ac.types.includes("country")
        )?.long_name;
        return (
          country === "United States" ||
          country === "Puerto Rico" ||
          country === "U.S. Virgin Islands" ||
          country === "American Samoa" ||
          country === "Northern Mariana Islands" ||
          country === "Guam"
        );
      });

      let multipleCities = usResult?.postcode_localities;

      let city = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("locality")
      )[0]?.long_name;

      let city1 = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("sublocality")
      )[0]?.long_name;

      let city2 = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("neighborhood")
      )[0]?.long_name;

      let city3 = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("administrative_area_level_3")
      )[0]?.long_name;

      let city4 = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("administrative_area_level_2")
      )[0]?.long_name;

      let state = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("administrative_area_level_1")
      )[0]?.long_name;

      let country = usResult?.address_components.filter(
        (ac) => ~ac.types.indexOf("country")
      )[0]?.long_name;

      if (country === "United States") {
        let allCities = [
          city,
          city1,
          city2,
          city3,
          city4,
          ...(multipleCities || []).flatMap((city) =>
            city.split(",").map((c) => c.trim())
          ),
        ];

        allCities = allCities.filter(Boolean);

        allCities = [...new Set(allCities)];

        allCities.sort((a, b) => a.localeCompare(b));

        if (allCities && allCities?.length === 1) {
          setBankCities([]);
          const filteredCity = allCities[0];
          setValueBankZip(filteredCity, state, country);
        } else if (allCities && allCities?.length > 0) {
          setBankCities(allCities);
          setValueBankZip(null, state, country);
        } else {
          setBankCities([]);
          setValueBankZip("", "", "");
          toast("Please provide the valid zip code");
        }
      }

      if (
        country === "Puerto Rico" ||
        country === "U.S. Virgin Islands" ||
        country === "American Samoa" ||
        country === "Northern Mariana Islands" ||
        country === "Guam"
      ) {
        let allCities = [
          city,
          city1,
          city2,
          city3,
          city4,
          state,
          ...(multipleCities || []).flatMap((city) =>
            city.split(",").map((c) => c.trim())
          ),
        ];

        allCities = allCities.filter(Boolean);

        allCities = [...new Set(allCities)];

        allCities.sort((a, b) => a.localeCompare(b));

        if (allCities && allCities?.length === 1) {
          setBankCities([]);
          const filteredCity = allCities[0];
          setValueBankZip(filteredCity, country, "United States");
        } else if (allCities && allCities?.length > 0) {
          setBankCities(allCities);
          setValueBankZip(null, country, "United States");
        } else {
          setBankCities([]);
          setValueBankZip("", "", "");
          toast("Please provide the valid zip code");
        }
      }

      if (
        country !== "United States" &&
        country !== "Puerto Rico" &&
        country !== "U.S. Virgin Islands" &&
        country !== "Northern Mariana Islands" &&
        country !== "Guam" &&
        country !== "American Samoa"
      ) {
        toast("Please provide the US zip code");
        setBankCities([]);
        setValueBankZip("", "", "");
      }
    } else {
      if (data !== undefined) {
        if (data && data?.status === "ZERO_RESULTS") {
          toast("Please provide the valid zip code");
          setBankCities([]);
          setValueBankZip("", "", "");
        } else {
          data?.error_message
            ? toast(`${data?.error_message}`)
            : toast("somthing went wrong");
          setBankCities([]);
          setValueBankZip("", "", "");
        }
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bankGeoCodeData]);

  const setValueBankZip = (city, state, country) => {
    setValue("beneficiary_city", city, {
      shouldValidate: true,
      shouldTouch: true,
      shouldDirty: true,
    });

    setValue("beneficiary_state", state, {
      shouldValidate: true,
      shouldTouch: true,
      shouldDirty: true,
    });

    setValue("beneficiary_country", country, {
      shouldValidate: true,
      shouldTouch: true,
      shouldDirty: true,
    });
  };
  const handleMaxNumber = (event) => {
    let { value, name } = event.target;
    if (name === "accountNumber") {
      event.target.value = value.slice(0, 30);
    }
    if (name === "routingNumber") {
      event.target.value = value.slice(0, 9);
    }
    if (name === "reRoutingNumber") {
      event.target.value = value.slice(0, 9);
    }
    if (name === "reAccNumber") {
      event.target.value = value.slice(0, 30);
    }
    if (name === "recipient_zip") {
      event.target.value = value.slice(0, 5);
      setZipCode(event.target.value);
    }
    if (name === "beneficiary_zip") {
      event.target.value = value.slice(0, 5);
      setBankZip(event.target.value);
    }
  };

  const handleKeyPress = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const numericRegex = /^[0-9\b]+$/;
    const isNumericKey = numericRegex.test(keyValue);
    const isNumericKeypad = keyCode >= 96 && keyCode <= 105;
    const isTabKey = keyCode === 9;

    if (!(isNumericKey || isNumericKeypad || isTabKey)) {
      event.preventDefault();
    }
  };

  const onSubmit = async (formData) => {
    if (isEmailPage || isNotificationPage) {
      setShowModal(true);
      setBankData(formData);
    } else {
      const transformData = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        branchName: formData.branchName,
        bankName: formData.bankName,
        accountType: formData.accountType,
        accountNumber: formData.accountNumber,
        subsidiaryName: formData.subsidiaryName,
        routingNumber: formData.routingNumber,
        userId: userInfo?.userId,
        createdBy: userInfo?.userId,
        userAddress: {
          addressLine1: formData.recipient_addressLine1,
          addressLine2: formData.recipient_addressLine2 || "",
          zip: formData.recipient_zip,
          city:
            formData.recipient_city === null
              ? formData.recipient_cityList
              : formData.recipient_city,
          state: formData.recipient_state,
          country: formData.recipient_country,
        },
        bankAddress: {
          addressLine1: formData.beneficiary_addressLine1,
          addressLine2: formData.beneficiary_addressLine2 || "",
          zip: formData.beneficiary_zip,
          city:
            formData.beneficiary_city === null
              ? formData.beneficiary_cityList
              : formData.beneficiary_city,
          state: formData.beneficiary_state,
          country: formData.beneficiary_country,
        },
      };
      const data = JSON.stringify(transformData);
      try {
        const res = await addBankDetail(data).unwrap();
        if (res?.successful) {
          toast(
            <div>
              <div className="upload mt-2">{res?.message}</div>
            </div>,
            {
              autoClose: true,
              closeOnClick: false,
              theme: "light",
              closeButton: true,
              hideProgressBar: true,
              className: "custom-toast-video-sigining",
            }
          );
          if (location?.state?.page === "bankDetailsList") {
            navigate(client_request_bankList_details, {
              state: {
                page: "bankDetailsList",
                transactionId: location?.state?.transactionId,
              },
            });
          } else {
            navigate(client_personal_bank_details);
          }
          refetchData();
        } else {
          toast.error(res?.message);
        }
      } catch (err) {
        toast.error(err?.data?.message || err.errorMessage);
      }
    }
  };

  const onClickYes = async () => {
    setShowModal(false);
    const requestBodyData = {
      firstName: bankData?.firstName,
      lastName: bankData?.lastName,
      branchName: bankData?.branchName,
      bankName: bankData?.bankName,
      accountType: bankData?.accountType,
      accountNumber: bankData?.accountNumber,
      subsidiaryName: bankData?.subsidiaryName,
      routingNumber: bankData?.routingNumber,
      userAddress: {
        addressLine1: bankData?.recipient_addressLine1,
        addressLine2: bankData?.recipient_addressLine2 || "",
        zip: bankData?.recipient_zip,
        city:
          bankData?.recipient_city === null
            ? bankData?.recipient_cityList
            : bankData?.recipient_city,
        state: bankData?.recipient_state,
        country: bankData?.recipient_country,
      },
      bankAddress: {
        addressLine1: bankData?.beneficiary_addressLine1,
        addressLine2: bankData?.beneficiary_addressLine2 || "",
        zip: bankData?.beneficiary_zip,
        city:
          bankData?.beneficiary_city === null
            ? bankData?.beneficiary_cityList
            : bankData?.beneficiary_city,
        state: bankData?.beneficiary_state,
        country: bankData?.beneficiary_country,
      },
    };
    if (isNotificationPage && userInfo?.firmTypeId !== 2) {
      try {
        const res = await requestShareBankDetail({
          user: {
            transactionId: transactionId,
            userId: userInfo?.userId,
          },
          data: requestBodyData,
        }).unwrap();
        if (res?.successful) {
          toast(
            <div>
              <div className="upload mt-2">{res?.message}</div>
            </div>,
            {
              autoClose: true,
              closeOnClick: false,
              theme: "light",
              closeButton: true,
              hideProgressBar: true,
              className: "custom-toast-video-sigining",
            }
          );
          if (userInfo?.role === "ATT") {
            navigate(attorney_LandingPage);
          } else if (userInfo?.role === "CLI") {
            navigate(client_LandingPage);
          }
          refetchData();
        } else {
          toast.error(res?.message);
        }
      } catch (err) {
        toast.error(err?.data?.message || err.errorMessage);
      }
    } else if (isEmailPage) {
      const securityKey = location?.state?.securityKey;
      if (securityKey) {
        try {
          const res = await shareBankDetails({
            user: {
              transactionId: transactionId,
              key: securityKey,
              identifierID: identifierID,
            },
            data: requestBodyData,
          }).unwrap();
          if (res?.successful) {
            toast(
              <div>
                <div className="upload mt-2">{res?.message}</div>
              </div>,
              {
                autoClose: true,
                closeOnClick: false,
                theme: "light",
                closeButton: true,
                hideProgressBar: true,
                className: "custom-toast-video-sigining",
              }
            );
            window.location.replace(famVault_wesbite);
          } else {
            toast.error(res?.message);
          }
        } catch (err) {
          toast.error(err?.data?.message || err.errorMessage);
        }
      }
    } else if (userInfo?.firmTypeId === 2) {
      const transformData = {
        firstName: bankData?.firstName,
        lastName: bankData?.lastName,
        branchName: bankData?.branchName,
        bankName: bankData?.bankName,
        accountType: bankData?.accountType,
        accountNumber: bankData?.accountNumber,
        subsidiaryName: bankData?.subsidiaryName,
        routingNumber: bankData?.routingNumber,
        userAddress: {
          addressLine1: bankData?.recipient_addressLine1,
          addressLine2: bankData?.recipient_addressLine2 || "",
          zip: bankData?.recipient_zip,
          city:
            bankData?.recipient_city === null
              ? bankData?.recipient_cityList
              : bankData?.recipient_city,
          state: bankData?.recipient_state,
          country: bankData?.recipient_country,
        },
        bankAddress: {
          addressLine1: bankData?.beneficiary_addressLine1,
          addressLine2: bankData?.beneficiary_addressLine2 || "",
          zip: bankData?.beneficiary_zip,
          city:
            bankData?.beneficiary_city === null
              ? bankData?.beneficiary_cityList
              : bankData?.beneficiary_city,
          state: bankData?.beneficiary_state,
          country: bankData?.beneficiary_country,
        },
        userId: userInfo?.userId,
        createdBy: userInfo?.userId,
      };
      const data = JSON.stringify(transformData);

      try {
        const res = await requestShareBankDetail({
          user: {
            transactionId: transactionId,
            userId: userInfo?.userId,
          },
          data: requestBodyData,
        }).unwrap();
        if (res?.successful) {
          try {
            const result = await addBankDetail(data).unwrap();
            if (result?.successful) {
              refetchData();
            } else {
              toast.error(result?.message);
            }
          } catch (err) {
            toast.error(err?.data?.message || err.errorMessage);
          }
          toast(
            <div>
              <div className="upload mt-2">{res?.message}</div>
            </div>,
            {
              autoClose: true,
              closeOnClick: false,
              theme: "light",
              closeButton: true,
              hideProgressBar: true,
              className: "custom-toast-video-sigining",
            }
          );
          if (userInfo?.role === "CLI") {
            navigate(client_LandingPage);
          }
          refetchData();
        } else {
          toast.error(res?.message);
        }
      } catch (err) {
        toast.error(err?.data?.message || err.errorMessage);
      }
    }
  };
  const handlePrevPage = () => {
    if (location?.state?.page === "bankDetails") {
      navigate(client_personal_bank_details);
    } else if (location?.state?.page === "bankDetailsList") {
      navigate(client_request_bankList_details, {
        state: {
          page: "bankDetailsList",
          transactionId: location?.state?.transactionId,
        },
      });
    } else {
      navigate(client_LandingPage);
    }
  };

  return (location?.state || userInfo) && isRightPath ? (
    <>
      {(isEmailPage || isAlreadyShared) && <HeaderProfileWireTransfer />}
      <div
        className="superadmin-container attorney-edit-client-page"
        data-testid="na-firmadmin-addclient"
      >
        <Container fluid className="px-lg-4">
          <div
            className="employee-title-page-container px-0 px-lg-4 px-md-4"
            data-testid="sa-addemployee-page"
          >
            <AttorneyTitleBar
              items={items}
              hasButton={false}
              title={"Bank Details"}
              navigateToPrev={handlePrevPage}
              hasBackButton={
                isEmailPage ||
                isNotificationPage ||
                isAlreadyShared ||
                isAlreadySharedNoti
                  ? false
                  : true
              }
            />
          </div>
          <div className="firm-page-outer-container firm-page-add-outer-container px-lg-4 px-md-4">
            {/* <div className="firm-page-container-wiretransfer employee-form-container ps-3 pt-lg-1 pt-md-1">
              {showRipon &&
                !isEmailPage &&
                !isNotificationPage &&
                !isAlreadyShared &&
                !isAlreadySharedNoti && (
                  <div className="update-info-box">
                    <span className="info-icon-addfamily mx-2">
                      <Info />
                    </span>
                    <span className="update-info-text pt-lg-2 pt-md-2">
                      Currently, only City National Bank is supported to
                      transfer your funds!
                    </span>
                    <CloseButton
                      className="close-button-ripon ms-3"
                      // variant="black"
                      onClick={() => {
                        setShowRipon(false);
                      }}
                    />
                  </div>
                )}
            </div> */}
            {/* <br className="custom-editor-wrapper" hidden={!showRipon}></br> */}
            <div className="firm-page-container employee-form-container">
              <Form
                className="custom-form employee-form px-2 pb-3 px-lg-4 px-md-4 type-2"
                autoComplete="off"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div
                  className="employee-title-page-container px-0 mt-2 py-2"
                  data-testid="sa-addemployee-page"
                >
                  <span className="page-title-bankdetails">
                    Personal Information
                  </span>
                </div>
                <Row>
                  <Col lg={12} md={12} className="mt-4">
                    <Row>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor="cli-firstname"
                            className="required mb-0"
                          >
                            {bankDetailsLabel.firstName}
                          </Form.Label>
                          <Form.Control
                            className="form-input"
                            type="text"
                            name="firstName"
                            autoComplete="off"
                            maxLength={30}
                            {...register("firstName")}
                            isInvalid={!!errors.firstName}
                            data-testid="cli-firstname"
                            id="cli-firstname"
                            disabled={isAlreadyShared || isAlreadySharedNoti}
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors.firstName?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label htmlFor="cli-lastname" className="mb-0">
                            {bankDetailsLabel.lastName}
                          </Form.Label>
                          <Form.Control
                            className="form-input"
                            type="text"
                            name="lastName"
                            maxLength={30}
                            autoComplete="off"
                            {...register("lastName")}
                            isInvalid={!!errors.lastName}
                            data-testid="cli-lastname"
                            id="cli-lastname"
                            disabled={isAlreadyShared || isAlreadySharedNoti}
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors.lastName?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor="recipient_addressLine1"
                            className="required mb-0"
                          >
                            {clientPlaceholder.addressLine1}
                          </Form.Label>
                          <Form.Control
                            className="form-input input-border-radius-unset"
                            type="text"
                            name="recipient_addressLine1"
                            maxLength={255}
                            autoComplete="off"
                            {...register("recipient_addressLine1")}
                            isInvalid={!!errors.recipient_addressLine1}
                            data-testid="recipient_addressLine1"
                            id="recipient_addressLine1"
                            disabled={isAlreadyShared || isAlreadySharedNoti}
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors.recipient_addressLine1?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor="recipient_addressLine2"
                            className="form-label mb-0"
                          >
                            {clientPlaceholder.addressLine2}
                          </Form.Label>
                          <Form.Control
                            className="form-input input-border-radius-unset"
                            type="text"
                            name="recipient_addressLine2"
                            maxLength={255}
                            autoComplete="off"
                            {...register("recipient_addressLine2")}
                            isInvalid={!!errors.recipient_addressLine2}
                            data-testid="recipient_addressLine2"
                            id="recipient_addressLine2"
                            disabled={isAlreadyShared || isAlreadySharedNoti}
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors.recipient_addressLine2?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor="recipient_zip"
                            className="required mb-0"
                          >
                            {clientPlaceholder.zip}
                          </Form.Label>
                          <Form.Control
                            className="form-input input-border-radius-unset input_number"
                            type="number"
                            name="recipient_zip"
                            autoComplete="off"
                            onKeyDown={handleKeyPress}
                            onChangeCapture={handleMaxNumber}
                            {...register("recipient_zip")}
                            isInvalid={!!errors.recipient_zip}
                            data-testid="recipient_zip"
                            id="recipient_zip"
                            disabled={isAlreadyShared || isAlreadySharedNoti}
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors.recipient_zip?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor="recipient_city"
                            className="required mb-0"
                          >
                            {clientPlaceholder.city}
                          </Form.Label>
                          {cities?.length > 0 && (
                            <>
                              <Form.Select
                                aria-label="Default select example"
                                className="form-input input-border-radius-unset select-placeholder"
                                name="recipient_city"
                                isInvalid={!!errors.recipient_cityList}
                                {...register("recipient_cityList")}
                                id="recipient_city"
                                data-testid="recipient_cityList"
                                disabled={
                                  isAlreadyShared || isAlreadySharedNoti
                                }
                              >
                                <option value="" hidden></option>
                                {cities?.length > 0 &&
                                  cities.map((item) => (
                                    <option key={item} value={item}>
                                      {item}
                                    </option>
                                  ))}
                              </Form.Select>
                              <Form.Control.Feedback
                                data-testid="invalid-feedback"
                                type="invalid"
                              >
                                {errors.recipient_cityList?.message}
                              </Form.Control.Feedback>
                            </>
                          )}
                          {cities?.length === 0 && (
                            <>
                              <Form.Control
                                className="form-input input-border-radius-unset"
                                type="text"
                                // name="city"
                                autoComplete="off"
                                {...register("recipient_city")}
                                isInvalid={!!errors.recipient_city}
                                disabled
                                data-testid="recipient_city"
                                id="recipient_city"
                              />
                              <Form.Control.Feedback
                                data-testid="invalid-feedback"
                                type="invalid"
                              >
                                {errors.recipient_city?.message}
                              </Form.Control.Feedback>
                            </>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor="recipient_state"
                            className="required mb-0"
                          >
                            {clientPlaceholder.state}
                          </Form.Label>
                          <Form.Control
                            className="form-input input-border-radius-unset"
                            type="text"
                            name="recipient_state"
                            autoComplete="off"
                            {...register("recipient_state")}
                            isInvalid={!!errors.recipient_state}
                            data-testid="recipient_state"
                            id="recipient_state"
                            disabled
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors.recipient_state?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor="recipient_country"
                            className="required mb-0"
                          >
                            {clientPlaceholder.country}
                          </Form.Label>
                          <Form.Control
                            className="form-input input-border-radius-unset"
                            type="text"
                            name="recipient_country"
                            autoComplete="off"
                            {...register("recipient_country")}
                            isInvalid={!!errors.recipient_country}
                            data-testid="recipient_country"
                            id="recipient_country"
                            disabled
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors.recipient_country?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <div
                      className="employee-title-page-container px-0 mt-1 py-2 mb-4"
                      data-testid="sa-addemployee-page"
                    >
                      <span className="page-title-bankdetails">
                        Bank Information
                      </span>
                    </div>
                    <Row>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor="cli-bankName"
                            className="required mb-0"
                          >
                            {bankDetailsLabel.bankName}
                          </Form.Label>
                          <Form.Control
                            className="form-input input-border-radius-unset"
                            type="text"
                            name="bankName"
                            maxLength={30}
                            autoComplete="off"
                            {...register("bankName")}
                            isInvalid={!!errors.bankName}
                            data-testid="cli-bankName"
                            id="cli-bankName"
                            disabled={isAlreadyShared || isAlreadySharedNoti}
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors.bankName?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor="cli-branchName"
                            className="required mb-0"
                          >
                            {bankDetailsLabel.branchName}
                          </Form.Label>
                          <Form.Control
                            className="form-input"
                            type="text"
                            name="branchName"
                            inputMode="text"
                            autoComplete="off"
                            maxLength={30}
                            {...register("branchName")}
                            isInvalid={!!errors.branchName}
                            data-testid="cli-branchName"
                            id="cli-branchName"
                            disabled={isAlreadyShared || isAlreadySharedNoti}
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors.branchName?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor="cli-accountNumber"
                            className="required mb-0"
                          >
                            {bankDetailsLabel.accountNumber}
                          </Form.Label>
                          <Form.Control
                            className="form-input bank-account-number"
                            type="text"
                            name="accountNumber"
                            inputMode="text"
                            autoComplete="off"
                            onKeyDown={handleKeyPress}
                            onChangeCapture={handleMaxNumber}
                            {...register("accountNumber")}
                            isInvalid={!!errors.accountNumber}
                            data-testid="cli-accountNumber"
                            id="cli-accountNumber"
                            onPaste={(event) => event.preventDefault()}
                            disabled={isAlreadyShared || isAlreadySharedNoti}
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors.accountNumber?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor="cli-reAccNumber"
                            className="required mb-0"
                          >
                            {bankDetailsLabel.reAccNumber}
                          </Form.Label>
                          <Form.Control
                            className="form-input input-border-radius-unset account-number-x"
                            type="number"
                            name="reAccNumber"
                            onKeyDown={handleKeyPress}
                            onChangeCapture={handleMaxNumber}
                            autoComplete="off"
                            {...register("reAccNumber")}
                            isInvalid={!!errors.reAccNumber}
                            data-testid="cli-reAccNumber"
                            id="cli-reAccNumber"
                            onPaste={(event) => event.preventDefault()}      
                            disabled={isAlreadyShared || isAlreadySharedNoti}
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors.reAccNumber?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor="cli-accountType"
                            className="required mb-0"
                          >
                            {bankDetailsLabel.accountType}
                          </Form.Label>
                          <Form.Select
                            aria-label="Default select example"
                            className="form-input input-border-radius-unset select-placeholder"
                            name="city"
                            isInvalid={!!errors.accountType}
                            {...register("accountType")}
                            id="cli-accountType"
                            data-testid="cli-accountType"
                            disabled={isAlreadyShared || isAlreadySharedNoti}
                          >
                            <option value="" hidden></option>
                            {accountType &&
                              accountType.length > 0 &&
                              accountType.map((relation, index) => {
                                return (
                                  <option
                                    key={"relation" + index}
                                    value={relation.id}
                                  >
                                    {relation.label}
                                  </option>
                                );
                              })}
                          </Form.Select>
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors.accountType?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label htmlFor="cli-swiftCode" className="required mb-0">
                            {bankDetailsLabel.subsidiaryName}
                          </Form.Label>
                          <Form.Control
                            className="form-input"
                            type="text"
                            name="subsidiaryName"
                            autoComplete="off"
                            maxLength={30}
                            {...register("subsidiaryName")}
                            isInvalid={!!errors.subsidiaryName}
                            data-testid="cli-swiftCode"
                            id="cli-swiftCode"
                            disabled={isAlreadyShared || isAlreadySharedNoti}
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors.subsidiaryName?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor="cli-routingNumber"
                            className="required mb-0"
                          >
                            {bankDetailsLabel.routingNumber}
                          </Form.Label>
                          <Form.Control
                            className="form-input bank-account-number"
                            type="text"
                            name="routingNumber"
                            inputMode="text"
                            autoComplete="off"
                            onKeyDown={handleKeyPress}
                            onChangeCapture={handleMaxNumber}
                            {...register("routingNumber")}
                            isInvalid={!!errors.routingNumber}
                            data-testid="cli-routingNumber"
                            id="cli-routingNumber"
                            disabled={isAlreadyShared || isAlreadySharedNoti}
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors.routingNumber?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor="cli-reRoutingNumber"
                            className="required mb-0"
                          >
                            {bankDetailsLabel.reRoutingNumber}
                          </Form.Label>
                          <Form.Control
                            className="form-input input-border-radius-unset"
                            type="text"
                            name="reRoutingNumber"
                            autoComplete="off"
                            onKeyDown={handleKeyPress}
                            onChangeCapture={handleMaxNumber}
                            {...register("reRoutingNumber")}
                            isInvalid={!!errors.reRoutingNumber}
                            data-testid="cli-reRoutingNumber"
                            id="cli-reRoutingNumber"
                            disabled={isAlreadyShared || isAlreadySharedNoti}
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors.reRoutingNumber?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor="beneficiary_addressLine1"
                            className="required mb-0"
                          >
                            {clientPlaceholder.addressLine1}
                          </Form.Label>
                          <Form.Control
                            className="form-input input-border-radius-unset"
                            type="text"
                            name="beneficiary_addressLine1"
                            maxLength={255}
                            autoComplete="off"
                            {...register("beneficiary_addressLine1")}
                            isInvalid={!!errors.beneficiary_addressLine1}
                            data-testid="beneficiary_addressLine1"
                            id="beneficiary_addressLine1"
                            disabled={isAlreadyShared || isAlreadySharedNoti}
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors.beneficiary_addressLine1?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor="beneficiary_addressLine2"
                            className="form-label mb-0"
                          >
                            {clientPlaceholder.addressLine2}
                          </Form.Label>
                          <Form.Control
                            className="form-input input-border-radius-unset"
                            type="text"
                            name="beneficiary_addressLine2"
                            maxLength={255}
                            autoComplete="off"
                            {...register("beneficiary_addressLine2")}
                            isInvalid={!!errors.addressLine2}
                            data-testid="beneficiary_addressLine2"
                            id="beneficiary_addressLine2"
                            disabled={isAlreadyShared || isAlreadySharedNoti}
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors.addressLine2?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor="beneficiary_zip"
                            className="required mb-0"
                          >
                            {clientPlaceholder.zip}
                          </Form.Label>
                          <Form.Control
                            className="form-input input-border-radius-unset input_number"
                            type="number"
                            name="beneficiary_zip"
                            autoComplete="off"
                            onKeyDown={handleKeyPress}
                            onChangeCapture={handleMaxNumber}
                            {...register("beneficiary_zip")}
                            isInvalid={!!errors.beneficiary_zip}
                            data-testid="beneficiary_zip"
                            id="beneficiary_zip"
                            disabled={isAlreadyShared || isAlreadySharedNoti}
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors.beneficiary_zip?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor="beneficiary_city"
                            className="required mb-0"
                          >
                            {clientPlaceholder.city}
                          </Form.Label>
                          {bankcities?.length > 0 && (
                            <>
                              <Form.Select
                                aria-label="Default select example"
                                className="form-input input-border-radius-unset select-placeholder"
                                name="beneficiary_city"
                                isInvalid={!!errors.beneficiary_cityList}
                                {...register("beneficiary_cityList")}
                                id="beneficiary_city"
                                data-testid="beneficiary_cityList"
                                disabled={
                                  isAlreadyShared || isAlreadySharedNoti
                                }
                              >
                                <option value="" hidden></option>
                                {bankcities?.length > 0 &&
                                  bankcities.map((item) => (
                                    <option key={item} value={item}>
                                      {item}
                                    </option>
                                  ))}
                              </Form.Select>
                              <Form.Control.Feedback
                                data-testid="invalid-feedback"
                                type="invalid"
                              >
                                {errors.beneficiary_cityList?.message}
                              </Form.Control.Feedback>
                            </>
                          )}
                          {bankcities?.length === 0 && (
                            <>
                              <Form.Control
                                className="form-input input-border-radius-unset"
                                type="text"
                                // name="city"
                                autoComplete="off"
                                {...register("beneficiary_city")}
                                isInvalid={!!errors.beneficiary_city}
                                disabled
                                data-testid="beneficiary_city"
                                id="beneficiary_city"
                              />
                              <Form.Control.Feedback
                                data-testid="invalid-feedback"
                                type="invalid"
                              >
                                {errors.beneficiary_city?.message}
                              </Form.Control.Feedback>
                            </>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor="beneficiary_state"
                            className="required mb-0"
                          >
                            {clientPlaceholder.state}
                          </Form.Label>
                          <Form.Control
                            className="form-input input-border-radius-unset"
                            type="text"
                            name="beneficiary_state"
                            autoComplete="off"
                            {...register("beneficiary_state")}
                            isInvalid={!!errors.beneficiary_state}
                            data-testid="beneficiary_state"
                            id="beneficiary_state"
                            disabled
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors.beneficiary_state?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6} md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            htmlFor="beneficiary_country"
                            className="required mb-0"
                          >
                            {clientPlaceholder.country}
                          </Form.Label>
                          <Form.Control
                            className="form-input input-border-radius-unset"
                            type="text"
                            name="beneficiary_country"
                            autoComplete="off"
                            {...register("beneficiary_country")}
                            isInvalid={!!errors.beneficiary_country}
                            data-testid="beneficiary_country"
                            id="beneficiary_country"
                            disabled
                          />
                          <Form.Control.Feedback
                            data-testid="invalid-feedback"
                            type="invalid"
                          >
                            {errors.beneficiary_country?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <div className="d-flex justify-content-center mt-lg-2 mt-md-2">
                  <Button
                    type="submit"
                    className="custom-button btn-standard btn-reset btn-onboarding submit-z-index"
                    data-testid="submit-button"
                tabIndex={0}
                    disabled={isAlreadyShared || isAlreadySharedNoti}
                  >
                    {buttonName}
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </Container>
      </div>
      {showModal && (
        <BankShareConfirmationPopup
          setShowCallback={() => setShowModal(false)}
          setYesCallback={onClickYes}
          content={`Are you sure you want to share the bank details?`}
          showModal={showModal}
        />
      )}
      {(addBankDetailLoading ||
        requestShareBankDetailLoading ||
        shareBankDetailsLoading ||
        bankGeoCodeLoading ||
        geoCodeLoading) && <Loader />}
    </>
  ) : null;
}
